export default __webpack_public_path__ + "static/media/SurveyorText-LightItalic.02e804e7.woff2";